import {ExpenseType} from "../Data/Data";


export function getExpenseTypeLabel(type: ExpenseType): string {
    if (type === ExpenseType.CarKilometers) {
        return 'Personalwagen Kilometer';
    }
    if (type === ExpenseType.MotorCycleKilometers) {
        return 'Motorrad Kilometer';
    }
    return 'Kleinspesen';
}

export function getExpenseUnit(type: ExpenseType) {
    if (type === ExpenseType.Default) {
        return 'CHF';
    }
    return 'KM';
}

export class ExpenseTypeDialog {
    open(callback: (type: ExpenseType) => void) {

    }
}
